import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

interface CreateModalProps {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  onCreate: (name: string, description?: string) => void;
}

export function CreateDashboardModal({ open, onOpenChange, onCreate }: CreateModalProps) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  function handleSubmit() {
    if (!name.trim()) return;
    onCreate(name.trim(), description.trim() || undefined);
    setName("");
    setDescription("");
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-8 flex flex-col gap-6">
        <DialogTitle>New Dashboard</DialogTitle>
        <DialogDescription className="sr-only">
          Fill in the details to create a new dashboard.
        </DialogDescription>

        <div className="flex flex-col gap-5">
          <label className="flex flex-col gap-2">
            <span className="text-xs font-medium text-secondary uppercase tracking-wide">Name</span>
            <Input
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              placeholder="My Dashboard"
              maxLength={64}
            />
          </label>

          <label className="flex flex-col gap-2">
            <span className="text-xs font-medium text-secondary uppercase tracking-wide">
              Description <span className="normal-case font-normal text-muted">(optional)</span>
            </span>
            <Textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="A short description…"
              rows={2}
              maxLength={256}
            />
          </label>
        </div>

        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button size="sm" onClick={handleSubmit} disabled={!name.trim()}>
            Create
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
